<template>
  <section id="login_container">
    <div class="contents_wrap">
      <div>
        <h1 class="login_small_title_wrap">
          <img src="@/assets/img/etners-main/eskiosk_logo.png">
        </h1>
        <form method="post" v-kendo-validator @submit.prevent="loginProcess(userId, userPwd)" class="k-form">
          <fieldset>
            <label class="k-form-field">
              <input
                  type="text"
                  style="padding-left: 12px;"
                  id="userId"
                  name="userId"
                  class="login_input"
                  v-model="userId"
                  maxlength="20"
                  placeholder="아이디" autofocus
              >
            </label>
            <label class="k-form-field">
              <input
                  type="password"
                  id="userPwd"
                  name="userPwd"
                  class="login_input"
                  v-model="userPwd"
                  maxlength="50"
                  placeholder="비밀번호"
              >
            </label>
            <label class="k-form-field mtb10">
              <input type="checkbox" id="auth-2fa" name="all" class="k-checkbox" v-model="checked">
              <label class="k-checkbox-label" for="auth-2fa">아이디 기억하기</label>
            </label>
            <button type="submit" class="mid_btn orange login_btn"> 로그인</button>
          </fieldset>
          <div class="kfont">
            <router-link :to="{ name: 'FindAccount', params: {prop_active: 0 } }" tag="a">아이디 찾기</router-link>
            <router-link :to="{ name: 'FindAccount', params: {prop_active: 2 } }" tag="a">비밀번호 변경</router-link>
          </div>
        </form>
      </div>
    </div>
    <login-auth-window
        ref="loginAuthWindowRef"
        :user-id="authUserId"
        :login-user-token="authLoginUserToken"
        @verified="completeLogin"
    >
    </login-auth-window>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import util from '@/common/util'
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import EtnersCommonUtil from '@/common/etners.common.util'
import EtnersEncDecUtil from '@/common/etners.encDec.util'
import LoginAuthWindow from '@/components/LoginAuthWindow'

const eklDomain = ApiConfig.eklDomain

export default {
  name: 'Login',
  components: { LoginAuthWindow },
  data () {
    return {
      userId: window.localStorage.getItem('savedUserId'),
      userPwd: null,
      checked: null,
      publicKey: '',
      authUserId: '',
      authLoginUserToken: '',
      authLoginUserData: null,
    }
  },
  async mounted () {
    const vm = this
    let savedUserId = util.getUserSavedId()
    let existSavedUserIdFl = false
    if (savedUserId !== '' && savedUserId != null) {
      existSavedUserIdFl = true
    }
    vm.checked = existSavedUserIdFl
    this.$store.dispatch('initPublicKey') // 공개키 세팅
  },
  computed: {
    ...mapState({
      loginErrors: state => state.loginStore.loginErrors,
    }),
  },
  methods: {
    async onSubmit (userId, userPwd) {
      const vm = this
      let router = this.$router

      // 스토어에 공개키가 아직 세팅되지 않았거나(비동기 dispatch 미완료/실패) 유효하지 않으면 직접 재발급
      let publicKey = this.$store.state.encStoreModule.enc.data
      if (!publicKey || !publicKey.publicKeyModulus) {
        publicKey = await EtnersEncDecUtil.getRSA()
      }
      if (!publicKey || !publicKey.publicKeyModulus) {
        kendo.alert('보안키를 발급받지 못했습니다. 잠시 후 다시 시도해주세요.')
        return false
      }
      const loginParams = await EtnersCommonUtil.loginParams(userId,userPwd,publicKey)
      // 로그인
      ApiUtil.post(`${eklDomain}/v1/ebmp/ai/manager/auth/login.json`, loginParams).then(function (response) {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode === '4044') { // 비밀번호 90일 초과
          vm.moveToChangePw(userId, userPwd)
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }

        /**
         * 2차인증 팝업
         */
        let loginUserData = response.data.resultData
        let loginUserToken = loginUserData.loginUserToken

        vm.authUserId = userId
        vm.authLoginUserToken = loginUserToken
        vm.authLoginUserData = loginUserData

        vm.$refs.loginAuthWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
      })
    },
    /**
     * 2차 인증 성공 시 호출 (LoginAuthWindow @verified)
     * 기존 로그인 후속 처리(firstAccessInfo 조회 → 세션 저장 → 메인 이동)
     */
    completeLogin (newLoginUserToken) {
      const vm = this
      const loginUserToken = newLoginUserToken || sessionStorage.getItem('loginUserToken') || vm.authLoginUserToken
      vm.authLoginUserToken = loginUserToken

      const firstAccessParams = {
        loginUserToken: loginUserToken,
        wmGbn: '01',
      }

      ApiUtil.post(`${eklDomain}/v1/ebmp/ai/manager/auth/firstAccessInfo.json`, firstAccessParams).then(function (response) {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
          return false
        }

        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }
        /**
         * firstAccessInfo 데이터 가져온 시점
         */
        let firstAccessInfoResultData = response.data.resultData
        const userAuthCd = firstAccessInfoResultData.authCd
        const isFirstLogin = firstAccessInfoResultData.isFirstLogin

        sessionStorage.setItem('loginUserToken', loginUserToken)
        sessionStorage.setItem('isFirstLogin', isFirstLogin)
        sessionStorage.setItem('loginUserData', JSON.stringify(firstAccessInfoResultData))
        sessionStorage.setItem('userInfo', JSON.stringify(vm.authLoginUserData))

        vm.$router.push({
          name: 'Main'
        }).catch(() => {
          // Redirected Error 방지용 catch --jhkim
        })
      })
    },
    loginProcess (userId, userPwd) {
      const vm = this
      let validator = this.kendoValidator

      //만약 여러번 로그인이 수행되었을 경우를 대비해서 기존 데이터를 삭제한다.
      sessionStorage.removeItem('userInfo')
      sessionStorage.removeItem('isFirstLogin')
      sessionStorage.removeItem('loginUserToken')
      sessionStorage.removeItem('loginUserData')

      if (validator.validate()) {

        if (userPwd == null) {
          kendo.alert('비밀번호를 입력해주세요.')
          return false
        }

        // if (userPwd.length < 8) {
        //   kendo.alert('비밀번호 항목의 값은 최소 8글자이어야 합니다.')
        //   return false
        // }
        // id 기억하기가 체크 시 localstorage 저장
        if (this.checked) {
          util.saveUserId(userId)
        } else {
          util.destroyUserId(userId)
        }

        vm.onSubmit(userId, userPwd)
      }
    },
    moveToChangePw: function (userId, userPwd){
      const vm = this
      vm.$router.push({
        name: 'ChangePW',
        params: {
          'userId' : userId,
          'userPwd': userPwd
        }
      })
    },
  },
}
</script>
